// Used only on admin panel. Do not use for New UI!
export const gray = '#c2c5cc';
export const orange = '#f68d2e';
export const blue = '#00b6fb';
export const green = '#4fb646';
export const red = '#ff470d';

export const tertiary600 = '#f8c35a';

export const talentIndex70 = '#FBC697';
export const talentIndex80 = '#C0E7F4';
export const talentIndex90 = '#BDE3AD';
